const isValidTrack = (track) => Boolean(track?.id && track?.startingAt);

const getTime = (value) => {
    const time = new Date(value).getTime();
    return Number.isNaN(time) ? 0 : time;
};

export const getSpacePlaylist = (space) => {
    const tracks = [
        ...(space?.last_tracks || []),
        space?.current_track,
        ...(space?.next_tracks || []),
    ].filter(isValidTrack);

    const uniqueTracks = new Map();
    tracks.forEach((track) => {
        uniqueTracks.set(`${track.id}-${track.startingAt}`, track);
    });

    return [...uniqueTracks.values()].sort((a, b) => getTime(a.startingAt) - getTime(b.startingAt));
};

export const syncSpaceToProgramDateTime = (space, programDateTime) => {
    if (!space || !programDateTime) return space;

    const playlist = getSpacePlaylist(space);
    if (playlist.length === 0) return space;

    const programTime = getTime(programDateTime);
    if (!programTime) return space;

    const currentIndex = playlist.reduce((selectedIndex, track, index) => {
        const startsAt = getTime(track.startingAt);
        return startsAt <= programTime ? index : selectedIndex;
    }, -1);

    if (currentIndex < 0) return space;

    const currentTrack = playlist[currentIndex];

    return {
        ...space,
        current_track: currentTrack,
        last_tracks: playlist.slice(0, currentIndex).reverse(),
        next_tracks: playlist.slice(currentIndex + 1),
        playlist,
    };
};
